"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CompleteInvoicesAlt = class CompleteInvoicesAlt extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_register_entry_subject_enabled = new core_1.ComponentValueCache(this, "register_entry_subject_enabled", "IssueInvoices.register_entry_subject_enabled");
        this.$$cache_payload = new core_1.ComponentValueCache(this, "payload", "IssueInvoices.payload_v2");
    }
    formId;
    onForm_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    labelAlign;
    register_entry_subject_enabled;
    payload;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['labelAlign', 'register_entry_subject_enabled', 'payload', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: "right",
                register_entry_subject_enabled: false,
                payload: {
                    print: false,
                    print_copies: 1,
                    printer: null,
                    target: "remote",
                    create_register_entry: false,
                    register_entry_subject: null,
                },
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("CompleteInvoices|Title", "Complete Invoices"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7256_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_closeComponent_7258_getActionArgs($event) {
        return {
            result: {
                cancel: true,
            },
        };
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_4186377094414664_closeComponent_7260_getActionArgs($event) {
        return {
            result: {
                close: true,
                ok: true,
                value: _.extend({}, this.payload, {
                    register_entry_subject: this.payload.create_register_entry && this.register_entry_subject_enabled
                        ? this.payload.register_entry_subject
                        : null,
                    printer: this.payload.print && this.payload.printer
                        ? { id: this.payload.printer.id }
                        : null
                }),
            },
        };
    }
    async evh_4186377094414664_submit(event, scope) {
        return await this.actions.evh_4186377094414664_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7256 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7256_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7255 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7256,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7255],
        });
        const act_2248226175642056_closeComponent_7258 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_2248226175642056_closeComponent_7258_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_close_7257 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_7258,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_7257],
        });
        const act_4186377094414664_closeComponent_7260 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_4186377094414664_closeComponent_7260_getActionArgs,
            displayName: "submit",
            events: [],
        });
        const evh_4186377094414664_submit_7259 = new core_1.actions.EventHandlerImpl({
            action: act_4186377094414664_closeComponent_7260,
            event: "submit",
            displayName: "submit",
        });
        const evh_4186377094414664_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4186377094414664_submit_7259],
        });
        const act_1419464017721962_closeComponent_7262 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_7261 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_7262,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_7261],
        });
        return {
            act_7315092382398562_closeModal_7256,
            evh_7315092382398562_close_7255,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_7258,
            evh_2248226175642056_close_7257,
            evh_2248226175642056_close,
            act_4186377094414664_closeComponent_7260,
            evh_4186377094414664_submit_7259,
            evh_4186377094414664_submit,
            act_1419464017721962_closeComponent_7262,
            evh_1419464017721962_clickPreventStop_7261,
            evh_1419464017721962_clickPreventStop,
            submit: act_4186377094414664_closeComponent_7260,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: function () {
            return this.$fn.randomElementId();
        },
    }),
    __metadata("design:type", String)
], CompleteInvoicesAlt.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CompleteInvoicesAlt.prototype, "onForm_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], CompleteInvoicesAlt.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CompleteInvoicesAlt.prototype, "onSize", null);
CompleteInvoicesAlt = __decorate([
    (0, vue_property_decorator_1.Component)()
], CompleteInvoicesAlt);
exports.default = CompleteInvoicesAlt;
vue_property_decorator_1.Vue.component("CompleteInvoicesAlt", CompleteInvoicesAlt);
